var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBifrost = function SvgIconBifrost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10M9.698 5.47c1.394-.383 2.776.676 2.774 2.144q0 .262-.06.51-.387 0-.783.107l-4.318 1.19L5.603 6.6zm3.555 2.145q0 .314-.063.612a3 3 0 0 1 2.202 2.898 2.996 2.996 0 0 1-2.186 2.891l-5.185 1.44-2.549-4.211 5.386-1.495c.482-.134.89-.425 1.176-.81a2 2 0 0 0-.197.045L6.948 10.33 4.4 6.12l5.09-1.403c1.901-.523 3.766.922 3.763 2.898m-2.186 2.887a2.98 2.98 0 0 0 1.864-1.535 2.21 2.21 0 0 1 1.68 2.158c0 1-.663 1.874-1.614 2.139l-4.614 1.28-1.709-2.822z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBifrost;